import React from 'react';

import {Grid2 as Grid, Typography, Divider, Skeleton} from 'views/components';
import {Translate} from 'views/module';

const ContactsSkeleton = () => {
  const renderSkeletonColumns = (keyPrefix, cells) => {
    return cells.map((cell, idx) => (
      <Grid
        key={`${keyPrefix}-${idx}`}
        size={1.5}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {cell}
      </Grid>
    ));
  };

  return (
    <Grid container spacing={1}>
      <Grid size={12}>
        <Typography
          sx={{
            fontWeight: 600,
          }}
        >
          <Translate expression='client.ClientDetail.Relationships.Contacts.Title' />
        </Typography>
      </Grid>
      <Grid size={12}>
        <Divider />
      </Grid>

      <Grid size={6}>
        <Skeleton variant="text" width={140} height={18} />
      </Grid>

      {
        renderSkeletonColumns('email-header', [
          <Skeleton key="notification" variant="text" width={120} height={18} />,
          <Skeleton key="authentication" variant="text" width={150} height={18} />,
        ])
      }

      <Grid
        size={6}
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Skeleton variant="text" width="70%" height={20} />
      </Grid>
      {
        renderSkeletonColumns('email-row-1', [
          <Skeleton key="notification" variant="rounded" width={80} height={28} />,
          <Skeleton key="authentication" variant="rounded" width={80} height={28} />,
        ])
      }


      <Grid
        size={6}
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Skeleton variant="text" width="60%" height={20} />
      </Grid>
      {
        renderSkeletonColumns('email-row-2', [
          <Skeleton key="notification" variant="rounded" width={80} height={28} />,
          <Skeleton key="authentication" variant="rounded" width={80} height={28} />,
        ])
      }

      <Grid size={12}>
        <Divider />
      </Grid>

      <Grid size={6}>
        <Skeleton variant="text" width={160} height={18} />
      </Grid>
      {
        renderSkeletonColumns('phone-header', [
          <Skeleton key="notification" variant="text" width={120} height={18} />,
          null,
          <Skeleton key="communication" variant="text" width={130} height={18} />,
          <Skeleton key="dialpad" variant="text" width={130} height={18} />,
        ])
      }
      <Grid
        size={6}
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Skeleton variant="text" width="55%" height={20} />
      </Grid>
      {
        renderSkeletonColumns('phone-row-1', [
          <Skeleton key="notification" variant="rounded" width={80} height={28} />,
          null,
          <Skeleton key="communication" variant="rounded" width={80} height={28} />,
          <Skeleton key="dialpad" variant="rounded" width={80} height={28} />,
        ])
      }
      <Grid
        size={6}
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Skeleton variant="text" width="50%" height={20} />
      </Grid>
      {
        renderSkeletonColumns('phone-row-2', [
          <Skeleton key="notification" variant="rounded" width={80} height={28} />,
          null,
          <Skeleton key="communication" variant="rounded" width={80} height={28} />,
          <Skeleton key="dialpad" variant="rounded" width={80} height={28} />,
        ])
      }
    </Grid>
  );
};

export default React.memo(ContactsSkeleton);
